import {
    Features,
    useFeatureFlagValue,
} from '@experiences/feature-flags';
import type { IPermissionActionDescriptor } from '@experiences/interfaces';

import { useHasAnyPermission } from '../../container/UserAuthPDPModelProvider/UserAuthPDPModelProvider';

/**
 * PDP check for a Relay action, gated on {@link Features.EnableRelayPermissionGating}.
 *
 * The `Relay.*` descriptors resolve only once the Relay service has registered them with
 * Authorization. While the flag is off this resolves to `true`, so an Authorization deploy
 * that lands after this UI cannot lock users out of controls they could previously use.
 */
export const useHasRelayPermission = (
    requiredActions: IPermissionActionDescriptor[],
    tenantId?: string,
): boolean => {
    const isPermissionGatingEnabled = useFeatureFlagValue(Features.EnableRelayPermissionGating.name);
    const hasPermission = useHasAnyPermission(requiredActions, tenantId ?? '');

    return !isPermissionGatingEnabled || hasPermission;
};
